<div class="load-scenario-item">
  <div class="details-column" (click)="loadItem(scenario.plannerScenarioId)">
    <mat-progress-bar mode="indeterminate" *ngIf="show"></mat-progress-bar>
    <label class="scenario-name"
      ><strong>{{ scenario.name }}</strong></label
    >
    <label class="scenario-date">{{ scenario.createdOn | date: 'dd.MM.yyyy' }} - {{ scenario.municipalityName }}</label>
    <label class="scenario-date">{{ 'module.modals.loadScenario.item.createdByScenarioLabelText' | translate }} {{ scenario.createdByName }}</label>
    <label class="scenario-date">{{ 'module.modals.loadScenario.item.adaptedFromScenarioLabelText' | translate }} {{ scenario.modifiedByName }}</label>
  </div>
  <label>
    <span
      class="fa fa-file-excel-o"
      (click)="saveInExcel(scenario.plannerScenarioId)"
      title="{{ 'module.modals.saveScenario.saveScenarioExcelTooltip' | translate }}"
    ></span>
  </label>
  <label>
    <span class="fa fa-trash" (click)="deleteItem(scenario.plannerScenarioId)"></span>
  </label>
</div>
